const t = {
  inline: !1,
  group: "block",
  attrs: {
    type: { default: "unsupportedElement" },
    unsupportedTypeName: { default: "" },
    text: { default: "" }
  },
  parseDOM: [],
  toDOM(e) {
    return ["div"];
  }
};
export {
  t as unsupportedElementSpec
};
